import React from 'react';
import { translate } from 'react-i18next';

import TimeSheetLocationNav from 'components/timesheets/TimeSheetLocationNav.js';
import TimeSheetItem from 'components/timesheets/TimeSheetItem.js';
import TimeSheetPreview from 'components/timesheets/TimeSheetPreview.js';

class PreviousTimeSheetPreview extends React.Component {
  constructor(props) {
    super(props);
    this._onApprove = this._onApprove.bind(this);
  }

  _onApprove(punch_ids) {
    if (!_.isEmpty(punch_ids)) {
      this.props.onApprovePunches(punch_ids);
    }
  }

  _renderTimeSheetPreview(data) {
    if (data != null) {
      return data.map(function (sheet) {
        return (
          <TimeSheetPreview
            shouldRender={data != null}
            type="previous"
            showHeader={false}
            data={sheet}
            activeState="active"
            punches={this.props.punches ? this.props.punches : {}}
            locations={this.props.locations ? this.props.locations : {}}
            currentLocation={this.props.currentLocation ? this.props.currentLocation : {}}
            displayBreakPunches={this.props.breakPunchesEnabled}
            onLocationChange={this.props.onLocationChange}
            onApprovePunches={this._onApprove.bind(this)}
            key={_.uniqueId()}
          />
        );
      }, this);
    }
  }

  render() {
    if (!this.props.shouldRender) {
      return false;
    }

    const { data, currentLocation } = this.props;
    const currentLocationName = !_.isEmpty(currentLocation) ? ` ${currentLocation.name} ` : ' ';;
    const pluralTimesheet = data.length > 1 ? this.props.t('PreviousTimeSheetPreview.timesheets') : this.props.t('PreviousTimeSheetPreview.timesheet');

    return (
      <div className={this.props.activeState}>
        <header>
          <div className="timesheet-meta-data">
            <h1>
              {this.props.t('PreviousTimeSheetPreview.previous')}
              {currentLocationName}
              {' '}
              {pluralTimesheet}
            </h1>
          </div>
          <TimeSheetLocationNav
            locations={this.props.locations}
            currentLocation={this.props.currentLocation}
            onLocationChange={this.props.onLocationChange}
          />
        </header>

        {this._renderTimeSheetPreview(data)}
      </div>
    );
  }
}

export default translate()(PreviousTimeSheetPreview);
